
import { Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { LogOut } from "lucide-react";

import logo from "../assets/logo.png";

import PortalLogo from "./PortalLogo";

import useRBAC from "../hooks/useRBAC";

import "./Sidebar.css";

export default function Sidebar({ onNavigate }) {
  const location = useLocation();
  const { accounts, instance } = useMsal();

  const handleNavClick = () => {
    onNavigate?.();
  };

  const handleSignOut = async () => {
    const currentUser = accounts?.[0];
    try {
      await instance.logoutRedirect({ account: currentUser });
    } catch {
      try {
        await instance.logoutPopup({ account: currentUser });
        window.location.href = "/";
      } catch (error) {
        console.error("Logout failed:", error);
      }
    }
  };

  const { hasAccess, isAdmin, loading } =
    useRBAC();

  /* ================= ACCESS WRAPPER ================= */

  const canAccess = (
    resources = [],
  ) => {
    if (isAdmin) {
      return true;
    }

    return resources.some(
      (resource) =>
        hasAccess(
          resource,
          "READ",
        ) ||
        hasAccess(
          resource,
          "WRITE",
        ),
    );
  };

  /* ================= MENU CONFIG ================= */

  const modules = [
    {
      label: "Upload Documents",

      path: "/upload",

      resources: [
        "UPLOAD_DOCUMENT",
      ],
    },

    {
      label: "Search Documents",

      path: "/search",

      resources: [
        "SEARCH_DOC",
        
      ],
    },

    {
      label:
        "Archival Policy Search",

      path: "/policy-search",

      resources: [
        "ARCHIVAL_POLICY_SEARCH",
      ],
    },

    // {
    //   label:
    //     "Archival Claim Search",

    //   path: "/claim-search",

    //   resources: [
    //     "ARCHIVAL_CLAIM_SEARCH",
    //   ],
    // },
  ];

  if (loading) {
    return (
      <div className="sidebar">
        {/* ===== TOP LOGO ===== */}

        <div className="sidebar-header">
          <PortalLogo variant="sidebar" />
        </div>

        <div
          style={{
            padding: "20px",
            color: "#94a3b8",
          }}
        >
          Loading menu...
        </div>

        <div className="sidebar-footer">
          <button
            type="button"
            className="sidebar-signout"
            onClick={handleSignOut}
          >
            <LogOut size={16} />
            Sign Out
          </button>

          <div className="sidebar1-footer-logo">
            <img
              src={logo}
              alt="CFP Logo"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sidebar">
      {/* ===== TOP LOGO ===== */}

      <div className="sidebar-header">
        <PortalLogo variant="sidebar" />
      </div>

      {/* ===== NAVIGATION ===== */}

      <div className="sidebar-nav">
        {/* DASHBOARD */}

        <Link
          to="/"
          onClick={handleNavClick}
          className={`nav-item ${
            location.pathname === "/"
              ? "active"
              : ""
          }`}
        >
          Dashboard
        </Link>

        {/* MODULES */}

        {modules.map((module) =>
          canAccess(
            module.resources,
          ) ? (
            <Link
              key={module.path}
              to={module.path}
              onClick={handleNavClick}
              className={`nav-item ${
                location.pathname ===
                module.path
                  ? "active"
                  : ""
              }`}
            >
              {module.label}
            </Link>
          ) : null,
        )}

        {/* DOCUMENT HUB */}

        {canAccess([
          "DOC_INDEX_HUB",
        ]) && (
          <>
            <div
              style={{
                height: "1px",
                background:
                  "rgba(255,255,255,0.08)",
                margin:
                  "14px 10px",
              }}
            />

            <div
              style={{
                padding:
                  "0 14px",
                fontSize:
                  "11px",
                color:
                  "#94a3b8",
                textTransform:
                  "uppercase",
                letterSpacing:
                  "0.08em",
                marginBottom:
                  "8px",
              }}
            >
              Document Index Hub
            </div>

            <Link
              to="/document-hub"
              onClick={handleNavClick}
              className={`nav-item ${
                location.pathname ===
                "/document-hub"
                  ? "active"
                  : ""
              }`}
            >
              Inbox Review
            </Link>
          </>
        )}

        {/* ADMIN SECTION */}

        {isAdmin && (
          <>
            <div
              style={{
                height: "1px",
                background:
                  "rgba(255,255,255,0.08)",
                margin:
                  "14px 10px",
              }}
            />

            <div
              style={{
                padding:
                  "0 14px",
                fontSize:
                  "11px",
                color:
                  "#94a3b8",
                textTransform:
                  "uppercase",
                letterSpacing:
                  "0.08em",
                marginBottom:
                  "8px",
              }}
            >
              Administration
            </div>

            <Link
              to="/admin-dashboard"
              onClick={handleNavClick}
              className={`nav-item ${
                location.pathname ===
                "/admin-dashboard"
                  ? "active"
                  : ""
              }`}
            >
              Admin Console
            </Link>

            <Link
              to="/manage"
              onClick={handleNavClick}
              className={`nav-item ${
                location.pathname ===
                "/manage"
                  ? "active"
                  : ""
              }`}
            >
              Manage
            </Link>
          </>
        )}
      </div>

      <div className="sidebar-footer">
        <button
          type="button"
          className="sidebar-signout"
          onClick={handleSignOut}
        >
          <LogOut size={16} />
          Sign Out
        </button>

        <div className="sidebar1-footer-logo">
          <img
            src={logo}
            alt="CFP Logo"
          />
        </div>
      </div>
    </div>
  );
}